import './functions';
import { wrapperBuilder } from './build';

export const DniScannerWrapper = wrapperBuilder.build();
